import React, { useEffect, useState, useContext } from "react";
import { Button, TextField } from '@mui/material';
import { useParams, useHistory } from "react-router-dom";
import InstanceLeftSidebar from "../../InstanceLeftSidebar";
import PageHeaderWithBreadcrumbs from "../../../../components/PageHeaderWithBreadcrumbs";
import { AuthContext } from "../../../../helpers/AuthContext";
import DataDashboard from '../../../../components/DataDashboard';

const InstanceDashboard = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [updates, setUpdates] = useState([]);
  const [newStatus, setNewStatus] = useState("");
  const { authState } = useContext(AuthContext);
  let history = useHistory();

  


  const salesData = [
    { id: 1, product: 'Product A', amount: 120, date: '2025-01-15' },
    { id: 2, product: 'Product B', amount: 200, date: '2025-01-16' },
    { id: 3, product: 'Product A', amount: 150, date: '2025-01-18' },
    { id: 4, product: 'Product C', amount: 250, date: '2025-02-01' },
    { id: 5, product: 'Product B', amount: 100, date: '2025-02-05' },
    { id: 6, product: 'Product A', amount: 300, date: '2025-02-07' },
  ];
  
  const columns = [
    { field: 'id', headerName: 'ID', width: 90 },
    { field: 'product', headerName: 'Product', width: 200 },
    { field: 'amount', headerName: 'Amount', width: 180 },
    { field: 'date', headerName: 'Date', width: 250 },
  ];


  useEffect(() => {
    setLoading(false);
  }, []);


  return (
    <div className="instance-dashboard">
      <InstanceLeftSidebar />
      <div className="rightSide">
        <div className="options-container fade-in-effect-usability">
          <div className="options-inner-container">
            <PageHeaderWithBreadcrumbs
              title="Finance Dashboard"
              breadcrumb="Finance Dashboard"
              includeButton={false}
            />
            {/* Data Table Section for Suppliers */}
            <DataDashboard data={salesData} columns={columns} type="Finance" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default InstanceDashboard;
